import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About us" },
  { to: "/toolkit", label: "Toolkit" },
  { to: "/contact", label: "Contact us" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  // Close the mobile menu on Escape for keyboard users.
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const linkClass = ({ isActive }) =>
    [
      "relative py-2 text-base font-medium transition-colors duration-200",
      isActive ? "text-melt-amber" : "text-[#FAF8F5]/90 hover:text-white",
    ].join(" ");

  return (
    <header
      className="sticky top-0 z-50 woven-texture border-b border-white/10"
      data-testid="site-navbar"
    >
      <nav
        className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 md:px-8"
        aria-label="Primary"
      >
        <Link
          to="/"
          className="group flex items-center"
          data-testid="navbar-logo-link"
          onClick={() => setOpen(false)}
        >
          <img
            src="/brand/melt-logo.webp"
            alt="MELT — MultiEthno-Linguistic Toolkit"
            className="h-10 w-auto md:h-12"
          />
        </Link>

        {/* Desktop nav */}
        <ul className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} end={item.end} className={linkClass} data-testid={`nav-link-${item.label.split(" ")[0].toLowerCase()}`}>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Mobile toggle */}
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-md p-2 text-[#FAF8F5] md:hidden"
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} aria-hidden="true" /> : <Menu size={26} aria-hidden="true" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div id="mobile-menu" className="woven-texture border-t border-white/10 md:hidden" data-testid="mobile-menu">
          <ul className="mx-auto flex max-w-6xl flex-col px-5 py-2">
            {NAV.map((item) => (
              <li key={item.to} className="border-b border-white/10 last:border-0">
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    [
                      "block py-4 text-lg font-medium",
                      isActive ? "text-melt-amber" : "text-[#FAF8F5]/90",
                    ].join(" ")
                  }
                  data-testid={`mobile-nav-link-${item.label.split(" ")[0].toLowerCase()}`}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
